<template>
  <div>
    <v-row class="ma-2" v-show="showMapsDiv||showMapsDiv2">
      <v-col cols="12" class="float-left" id="leftMenuC">       
        <!--<v-btn class="mr-2" :color="settings.options.color" :loading="loading" dark @click.stop="GetData()"><v-icon>mdi-sync-circle</v-icon></v-btn>-->
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn @click="GetData()" small v-bind="attrs" fab class="neu-glow mr-5" active-class="neu-glow-inset" v-on="on" :loading="loading">
              <v-icon 
                color="info"
                class="mx-3"
                active-class="neu-glow-inset"
                >
                  mdi-sync-circle
              </v-icon>
            </v-btn>
          </template>
          <span>Refresh</span>
        </v-tooltip>        
        
        <v-btn-toggle v-model="mealFilter" mandatory  :active-class="settings.options.color+' white--text'" v-if="meals" class="mr-2" v-show="meals.length>1">
          <v-btn 
            v-for="(m,m2) in meals" :key="m2"
            v-bind="attrs" v-on="on"
            elevation="5"
            height="40"
            class="px-3 blue-grey darken-2"
            :value="m.mealId"    
          >
            {{m.name}}
          </v-btn>
        </v-btn-toggle>
        
        <v-btn-toggle v-model="activeHallId" mandatory  :active-class="settings.options.color+' white--text'" v-if="halls" class="mr-2">
          <v-btn 
            v-for="(m,m2) in halls" :key="m2"
            v-bind="attrs" v-on="on"
            elevation="5"
            height="40"
            class="px-3 blue-grey darken-2"
            :value="m.hallId"
          >
          {{m.name}}
          </v-btn>
        </v-btn-toggle> 


        <v-btn-toggle v-model="activeSlot" mandatory :active-class="settings.options.color+' white--text'" class="background" v-if="vh">  
          <v-btn 
            class="px-3 blue-grey darken-2"
            height="40"
            :value="c1"
            v-for="(c,c1) in vh" :key="c1"
            :loading="loading"
          >
          {{c.name}}</v-btn>
        </v-btn-toggle>
        <!--<div class="d-inline ml-3">{{slctdTbls.map(t=>t.tableName)}}</div> -->
      </v-col> 
      <!--     
      <v-col cols="2" id="leftMenuD">
        <v-slider :min="0" :max="1" :step="0.01" @change="handleSliderChange"></v-slider>
      </v-col>
      -->
    </v-row> 

    <v-row class="text-center">
      <v-col cols="12" class="d-flex justify-center">
        <div class="warp-container">
          <div class="wrap">
            <div>
              <canvas id="mycanvas"></canvas>
            </div>
          </div>
          <div class="wrap2">
            <div>
              <canvas id="mycanvas2"></canvas>
            </div>
          </div>
            
        </div>
      </v-col>
    </v-row>
    <v-dialog
      v-model="dialogSave"
      max-width="600"
      style="overflow:hidden"
    >
      <v-card>
        <v-card-title class="text-h5">
          getVHall
          <v-spacer></v-spacer>
          <v-btn float icon>
            <v-icon color="success">mdi-content-save</v-icon>
          </v-btn>
          <v-btn float icon @click="dialogSave=false">
            <v-icon color="info">mdi-close</v-icon>
          </v-btn>            
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="mt-3">
          {{JSON.stringify(this.vh)}}
        </v-card-text>
      </v-card>
    </v-dialog> 
	</div>
</template>

<script>
  import Square from "./Square_out";
  import {DIRECTION} from "./Constant";
  import { mapGetters } from "vuex";
  export default {
    name: 'CanvasHallData',
    props: ['action','canvasWidth','canvasHeight','showMapsDiv','canv','bookingId','activeSlotId','activeMealId','activeLocationId','activeDate','activeCovers','activeMealDuration'],
    created(){
      console.log(116,this.settings)
      //this.$vuetify.theme.dark = this.settings.options.darkTheme;
      //this.$store.dispatch("scheme/setDarkTheme", true);
      console.log(119,this.settings);
      if (this.settings&&this.settings.brand==' ')
      {
        this.$router.push('/auth/login').catch(() => {});
      }
      else
      {
        this.GetData(0)
      }
    },
    watch:{
      
      activeHallId(newVal)
      {
        console.log(133,this.activeSlot,newVal)
        this.initTables(this.activeSlot||0,newVal)
      },
      activeLocationId(newVal)
      {
        console.log(138,this.activeLocationId,newVal)
        if(newVal)
        {
          this.activeHallId=this.halls.filter(h=>h.locationId==newVal)[0].hallId
          console.log(143,this.activeLocationId,this.activeHallId)
          //this.initTables(this.activeSlot,this.activeHallId)
          this.GetData(0)
        }
        else
        {
          this.activeHallId=this.halls[0].hallId
        }
        //this.initTables(this.activeSlot,newVal.hallId)
      },      
      activeMealId(newVal)
      {
        console.log(151,this.activeMealId,newVal)
        //this.initTables(this.activeSlot,newVal.hallId)
      },      
      activeSlot(newVal)
      {
        console.log(156,newVal,this.activeHallId)
        this.initTables(newVal,this.activeHallId)        
      },
      activeSlotId(newVal)
      {
        console.log(161,newVal,this.activeHallId)
        this.initTables(newVal,this.activeHallId)        
      },      
      activeDate(newVal)
      {
        console.log(166,newVal,this.activeDate,this.settings.date)
        this.GetData(0)       
      }, 
      bookingId(newVal)
      {
        console.log(171,newVal,this.bookingId)
        this.GetData(0)       
      },           
    },
    computed : {
      ...mapGetters(["settings"])
    },
    methods:{
      async GetData(row)
      {
        console.log(182,this.settings,this.settings.date,this.activeMealId,this.activeDate,this.activeLocationId,this.activeMealDuration,row)
        console.log(183,this.activeCovers)
        this.loading=true;
        this.dialog_connectionError=false;
        //this.bookings_previous=this.bookings?JSON.parse(JSON.stringify(this.bookings)):null;
        //try{
            const payload=JSON.stringify({"action":this.action,"payload":{"mealId": this.activeMealId,"locationId":this.activeLocationId,"date": this.settings.date,"bookingId":this.bookingId,"covers":this.activeCovers||0, "mealDuration":this.activeMealDuration, "reassign":0}});
            console.log(189,payload)
            const res = await this.$http.post('/manage/assign_map.php', payload );
            console.log(191,res)
            this.loading= false;
            switch (res.data.errorid)
            {
              case '0':
                  document.title = this.settings.brand+' | '+this.page;
                  sessionStorage.setItem('jwt', res.data.jwt);
                  console.log(198,res.data.payloads,this.activeLocationId)
                  //this.expired=res.data.payloads.expired;
                  this.vh=res.data.payloads;

                  this.halls=res.data.halls;
                  this.meals=res.data.meals;
                  //this.activeHallId=res.data.halls.filter(h=>h.locationId==this.activeLocationId)[0].hallId;
                  this.currentBooking=res.data.currentBooking;
                  if(this.currentBooking)
                  {
                    this.slctdTbls=this.currentBooking.tables?this.currentBooking.tables[0].split('-'):[];
                    this.activeHallId=res.data.currentBooking.hallId||this.halls.filter(h=>h.locationId==this.activeLocationId)[0].hallId;
                  }
                  else
                  {
                    this.slctdTbls=[];
                    this.activeHallId=this.halls.filter(h=>h.locationId==this.activeLocationId)[0].hallId;
                  }                  
                  //this.slctdTbls=this.currentBooking.tables?this.currentBooking.tables[0].split('-'):[];
                  //this.activeHallId=res.data.currentBooking.hallId||this.halls.filter(h=>h.locationId==this.activeLocationId)[0].hallId;
                  console.log(218,this.activeHallId)
                  //console.log(191,res.data.currentBooking.hallId)
                  console.log(220,this.halls.filter(h=>h.locationId==this.activeLocationId)[0].hallId)
                  //this.activeMealId=this.meals[0].mealId;
                  //console.log(152,this.vh[0].halls,this.vh[0].halls[0].hallId);
                  //this.initTables(0,this.vh[0].halls[0].hallId)
                  console.log(224,this.vh,this.activeHallId,this.activeMealId,this.halls, this.meals)
                  console.log(225,this.currentBooking)
                  //this.slctdTbls.push(this.vh[0].tables[32])
                  //console.log(191,this.slctdTbls)
                  this.initTables(0,this.activeHallId)
                  //return true;
              break;
              case '0007':
                var responsePayload=JSON.parse(res.data.payload)
                this.errorTitle=responsePayload.errorInfo[2];
                this.errorMessage=responsePayload.xdebug_message;
                console.log(235,res.data.payload,this.errorMessage,this.errorTitle)
                this.dialog_connectionError=true;
              break;
              case '0006':
                  this.$router.push('/auth/login').catch(() => {});
              break;
            }/*  
        } catch(e)
        {
          this.loading= false;
          this.dialog_connectionError=true;
        }*/
      },      

      cursorInRect(mouseX, mouseY, rectX, rectY, rectW, rectH, angle = 0) {

        let realRect = this.getRealMouseRect(rectX, rectY, rectW, rectH, angle);

        // let x = rectX + this.camera.x;
        // let y = rectY + this.camera.y;

        // let xLine = mouseX > x && mouseX < x + rectW
        // let yLine = mouseY > y && mouseY < y + rectH
        let xLine = mouseX > realRect.leftEdgeX && mouseX < realRect.rightEdgeX;
        let yLine = mouseY > realRect.topEdgeY && mouseY < realRect.bottomEdgeY;

        return xLine && yLine
      },

      getRealMouseRect(x, y, width, height, rotation) {
        // Define the rectangle properties
        // const x = 200; // x-coordinate of the rectangle
        // const y = 200; // y-coordinate of the rectangle
        // const width = 100; // width of the rectangle
        // const height = 50; // height of the rectangle
        // const rotation = 45; // rotation angle in degrees

        // Convert the rotation angle to radians
        const angleInRadians = rotation;

        // Calculate the center point of the rectangle
        const centerX = x + width / 2;
        const centerY = y + height / 2;

        // Calculate the coordinates of the four corners
        const topLeftX = Math.cos(angleInRadians) * (x - centerX) - Math.sin(angleInRadians) * (y - centerY) + centerX;
        const topLeftY = Math.sin(angleInRadians) * (x - centerX) + Math.cos(angleInRadians) * (y - centerY) + centerY;

        const topRightX = Math.cos(angleInRadians) * (x + width - centerX) - Math.sin(angleInRadians) * (y - centerY) + centerX;
        const topRightY = Math.sin(angleInRadians) * (x + width - centerX) + Math.cos(angleInRadians) * (y - centerY) + centerY;

        const bottomLeftX = Math.cos(angleInRadians) * (x - centerX) - Math.sin(angleInRadians) * (y + height - centerY) + centerX;
        const bottomLeftY = Math.sin(angleInRadians) * (x - centerX) + Math.cos(angleInRadians) * (y + height - centerY) + centerY;

        const bottomRightX = Math.cos(angleInRadians) * (x + width - centerX) - Math.sin(angleInRadians) * (y + height - centerY) + centerX;
        const bottomRightY = Math.sin(angleInRadians) * (x + width - centerX) + Math.cos(angleInRadians) * (y + height - centerY) + centerY;

        // Calculate the x and y coordinates of the edges
        const leftEdgeXTemp = Math.min(topLeftX, bottomLeftX);
        const rightEdgeXTemp = Math.max(topRightX, bottomRightX);
        const topEdgeYTemp = Math.min(topLeftY, topRightY);
        const bottomEdgeYTemp = Math.max(bottomLeftY, bottomRightY);

        const leftEdgeX = Math.min(leftEdgeXTemp, rightEdgeXTemp);
        const rightEdgeX = Math.max(leftEdgeXTemp, rightEdgeXTemp);
        const topEdgeY = Math.min(topEdgeYTemp, bottomEdgeYTemp);
        const bottomEdgeY = Math.max(topEdgeYTemp, bottomEdgeYTemp);

        return {
          topLeftX,
          topLeftY,
          topRightX,
          topRightY,
          bottomLeftX,
          bottomLeftY,
          bottomRightX,
          bottomRightY,
          leftEdgeX,
          rightEdgeX,
          topEdgeY,
          bottomEdgeY,
        }
      },

      handleScroll(event) {
        event.preventDefault(); // Prevent default scroll behavior

        const zoomSpeed = 0.01; // Adjust this value to control the zoom speed
        const scrollDelta = Math.sign(event.deltaY); // Get the scroll direction (1 for zoom in, -1 for zoom out)

        // Calculate the new zoom level
        this.zoomLevel -= scrollDelta * zoomSpeed;

        // Limit the zoom level to a specific range if desired
        // For example, you can use:
        console.log(292,this.zoomLevel)
        this.zoomLevel = Math.max(0.5, Math.min(this.zoomLevel, 8));
        console.log(294,this.zoomLevel)

        //   // Apply the zoom level to the canvas
        //   ctx2.clearRect(0, 0, canvas.width, canvas.height);
        //   ctx2.scale(zoomLevel, zoomLevel);

        // Redraw your canvas content here
        // ...
        ////this.drawBG(this.ctx2)

        // Reset the canvas scale to avoid cumulative scaling
          //   ctx2.setTransform(1, 0, 0, 1, 0, 0);
      },

      mouseUp() {
        this.dragTL = this.dragTR = this.dragBL = this.dragBR = false;
      },
      mouseDown(e,mouse) {
        //let mouse = getMouseCoords(canvas,this)
        console.log(41, e, mouse,this.dragTL,this.dragTR,this.dragBL,this.dragBR,this.mouseX,this.mouseY)
      },

      drawBG (context){
          context.clearRect(0, 0, this.canvas.width, this.canvas.height);
          context.scale(this.zoomLevel, this.zoomLevel);

          context.save()

          context.fillStyle = 'white'
          context.fillRect(0, 0, this.w / this.zoomLevel, this.h / this.zoomLevel)
          context.lineWidth = 0.3;
          context.strokeStyle = 'lightgray'
          context.fillStyle = 'black'
          console.log(325,'width : ', this.w, 'canvas : ', this.canvas.width,' zoomLevel: ',this.zoomLevel)
          for (let i = 1; i < this.w / this.zoomLevel; i++) {
              context.beginPath()
              if (i % 10 === 0) {
                  context.moveTo(i, 0);
                  context.lineTo(i, this.h / this.zoomLevel)
                  context.moveTo(i, 0);
              }
              context.closePath()
              context.stroke()
          }

          for (let i = 1; i < this.h / this.zoomLevel; i++) {
              context.beginPath()
              if (i % 10 === 0) {
                  context.moveTo(0, i)
                  context.lineTo(this.w / this.zoomLevel, i)
                  context.moveTo(0, i)
              }
              context.closePath()
              context.stroke()
          }


          context.lineWidth = 1
          context.strokeStyle = 'gray'

          context.beginPath()
          for (let i = 50; i < this.w / this.zoomLevel; i += 10) {
              if ((i - this.camera.x) % 50 === 0) {
                  context.moveTo(i, 0)
                  context.lineTo(i, 30)
                  context.fillText(` ${i - this.camera.x}`, i, 30)
              } else {
                  context.moveTo(i, 0)
                  context.lineTo(i, 10)
              }

          }
          context.closePath()
          context.stroke()

          context.beginPath()
          for (let i = 50 ; i < this.h / this.zoomLevel; i += 10) {
              if ((i - this.camera.y) % 50 === 0) {
                  context.moveTo(0, i)
                  context.lineTo(30, i)
                  context.fillText(` ${i - this.camera.y}`, 30, i)
              } else {
                  context.moveTo(0, i)
                  context.lineTo(10, i)
              }

          }
          context.closePath()
          context.stroke()
          context.restore()

          context.setTransform(1, 0, 0, 1, 0, 0);
      },
      getMouseCoords(canvas, event) {
        let canvasCoords = canvas.getBoundingClientRect()
        return {
            x: (event.clientX - canvasCoords.left) / this.zoomLevel,
            y: (event.clientY - canvasCoords.top) / this.zoomLevel
        }
      },
      getIt(type = '') {
          let json = [];
          if(type == 'tables') {
            this.prtcls.forEach(e => {
                json.push({
                    "active":true,
                    "tableId": e.tableId,
                    "tableName": e.tableName,
                    "width": e.w,
                    "height": e.h,
                    "shape": e.shape,
                    "x": e.x,
                    "y": e.y
                });
              })
          } else {
            this.prtcls.forEach(e => {
              json.push({
                  name: e.table,
                  xPos: e.x,
                  yPos: e.y
              })
            })
          }

          return json;
      },
      getSelectedData() {
        let json = [];


        this.prtcls.forEach(e => {
          if(e.resize) {
            json.push({
              "active":true,
              "tableId": e.tableId,
              "tableName": e.tableName,
              "width": e.w,
              "height": e.h,
              "shape": e.shape,
              "x": e.x,
              "y": e.y
            });
            //this.slctdTbls.push(e.tableName)
          }
        })

        return json
      },
      getVirtualHallData() {
        let tables = this.getIt('tables');
        this.vh[0]['tables'] = tables;
        console.log("Virtual Hall Json Data :  ", this.vh)
        console.log("Select Data Json : ", this.getSelectedData())				  
      },
      SetColor(e) {
        this.prtcls.forEach(p => {
          if(p.resize) {
            p.color = e.target.value;
          }
        })
      },

      SetColorAM(e) {
        this.prtcls.forEach(p => {
          if(p.resize) {
            p.color = e.target.value;
          }
        })
      },      
  /*
    table_button_active(t,b=null)
    {
        if(!b){
          b={ATA:this.ATA,bookingId:''}
        }
        //console.log(4054,t,t.tableId,t.details)
        //console.log(4055,b,b.bookingId,this.ATA)
        //console.log(4056,this.disabledTables)

        //var isDisabled=this.disabledTables.includes(t.tableId)
        var isCurrentBooking=(t.details&&JSON.parse(t.details).some(t=>t.bookingId===b.bookingId)) // is not booked by current booking
        var isBooked=t.details&&JSON.parse(t.details).some(ta=> {
          return (b.ATA > ta.lockFrom && b.ATA < ta.lockTo)
          })
        var isActive= !isDisabled&&!isBooked;
        //console.log(1680,t.name,'isActive',isActive,'=>isDisabled',isDisabled,'&&isCurrent(',isCurrentBooking,'||isBooked',isBooked,')')
        var rt=isDisabled?'error disable-events':(isBooked&&!isCurrentBooking?'warning disable-events':'');
        //if(t.name) console.log(4067,t.name,t.details,b.bookingId,'current:'+isCurrentBooking,'booked:'+isBooked,rt);
        return rt
    },
    */


      initTables(slot=0,hallId = null) {
          console.log(524,'initTables');
          //let json = this.vh[hallIdx]['tables'];
          //this.prtcls = new Array(json.length).fill().map((a,idx) => new Square(json[idx]))
          delete this.prtcls;
          let json=null;
          console.log(529,slot,hallId,this.vh,this.bookingId,this.activeSlotId,this.activeLocationId)
          if(this.bookingId)
          {
            //let slotName=this.vh.map(k=>k.tables.find(z=>z.bookingId==this.bookingId))[0].ETA;
            //console.log(504,slotName);
            slot=this.vh.findIndex(k=>k.slotId==this.activeSlotId);
            console.log(535,slot,hallId,this.wh);
            json = (this.vh[slot]['tables']).filter(f=>f.hallId==hallId);
            //json=this.vh.find(k=>k.name==this.vh.map(k=>k.tables.find(z=>z.bookingId==this.bookingId))[0].ETA)['tables'].filter(f=>f.hallId==hallId)
          }
          else
          {
            if (typeof this.activeSlotId === 'string')
            {
              slot=this.vh.findIndex(k=>k.slotId==this.activeSlotId);
              console.log(544,slot);
            }
            if(!hallId)
            {
              var hallsCount=this.halls.filter(h=>h.locationId==this.activeLocationId).length;
              if (hallsCount>1)
              {
                hallId=this.halls.filter(h=>h.locationId==this.activeLocationId)[0].hallId;
              }
              else
              {
                hallId=this.halls.find(h=>h.locationId==this.activeLocationId).hallId;
              }
            }            
            //hallId=!hallId?'E45B1EF9A888B834C27333F826F119DFE912B5B7':hallId;
            json = (this.vh[slot]['tables']).filter(f=>f.hallId==hallId);
          }
          console.log(561,json)
          this.prtcls = new Array(json.length).fill().map((a,idx) => new Square(json[idx]))
          var kk=this.prtcls.find(p=>p.bookingId==this.bookingId)
        
          console.log(565,this.prtcls,kk)
          if(kk)
          {
            for (const obj of this.prtcls) {
                if (obj.bookingId === this.bookingId) {
                  obj.color = '#ff00ff';
                }
              }
          }
          /*
          if(this.canv=='volante')
          {
            for (const obj of this.prtcls) {
                //console.log(564,obj.tableId,this.booking.tablesId)
                if(this.booking.tablesId.includes(obj.tableId)) 
                {
                  obj.color = '#ff99ff';
                }
              }
          }  
          */        


          var mWidth=this.halls.find(h=>h.hallId==hallId).maxWidth+10;
          var zoomWidth=this.canvas.width/mWidth;
          var mHeight=this.halls.find(h=>h.hallId==hallId).maxHeight+10;
          var zoomHeight=this.canvas.height/mHeight;
          var zoo=Math.min(zoomWidth,zoomHeight)

          console.log(592,mWidth,this.canvasWidth,this.canvas.width,zoomWidth,mHeight,this.canvasHeight,this.canvas.height,zoomHeight,zoo)
          this.zoomLevel = zoo;
          ////this.drawBG(this.ctx2)

          //console.log(this.prtcls,JSON.stringify(this.prtcls))
      },
      animate () {
          this.ctx.clearRect(0, 0, this.w, this.ctx.canvas.height)
          this.ctx.scale(this.zoomLevel, this.zoomLevel);

          this.ctx.fillStyle = 'white'
          let aa = [...this.prtcls];
          aa.reverse().forEach(e => {
              e.select = true
              e.camera = {...this.camera};
              e.draw(this.ctx)
              if(e.resize) {
                this.drawDragAnchor(e.x, e.y, e.w, e.h, e.angle);
              }
          })
          this.ctx.setTransform(1, 0, 0, 1, 0, 0);
          window.requestAnimationFrame(this.animate)
      },
      clearManualSelectedTables()
      {
        console.log(565);
        this.prtcls.forEach(e => {
          if (e.bookingId === this.bookingId )
          { 
                e.color='green';
                e.assigned=false;
          }
        })
      },
      handleSelect(e) {
        let mouse = this.getMouseCoords(this.canvas, e);
        let isSelect = false;
        console.log(502,isSelect,this.currentBooking)						 
        this.prtcls.forEach(e => {
          if (this.cursorInRect(mouse.x, mouse.y, e.x, e.y, e.w, e.h, e.angle) && (e.bookingId==null ||e.bookingId === this.bookingId )) {
              console.log(570,e.assigned,this.slctdTbls.includes(e.tableName))
              console.log(572,e.lastName,e.time,e.covers,e)
              //console.log(571,)
              //e.resize = e.resize==true?false:true
              if (this.canv!='imanager')
              {
                if (!this.slctdTbls.includes(e.tableName))
                {
                  console.log(577,this.slctdTbls.includes(e.tableName))
                  e.assigned=true;
                  //if (!this.slctdTbls.includes(e.tableName))
                  {
                    this.slctdTbls.push(e.tableName)
                    /*if (e.lastName==='')
                    {
                      e.lastName=this.currentBooking.lastName;
                      e.time=this.currentBooking.time;
                      e.duration=this.currentBooking.duration;
                      e.covers=this.currentBooking.covers;
                      e.children=this.currentBooking.children;

                    }
                    */
                    console.log(590,this.slctdTbls,e,e.lastName)
                    this.$emit('slctdAdd', e.tableId)
                    e.color2=e.color;
                    e.color='#ff00ff';
                  }
                }
                else
                {
                  e.color=e.color2||'green';
                  e.assigned=false;
                  this.$emit('slctdRem', e.tableId)
                  const idx = this.slctdTbls.indexOf(e.tableName);
                  if(idx>-1)
                  {
                    this.slctdTbls.splice(idx,1)
                  }
                  //this.slctdTbls=this.slctdTbls.filter(s=>s.tableId!==e.tableId)
                  console.log(579,this.slctdTbls,e)
                }
              }
          }
        })
        console.log(592,this.prtcls,this.slctdTbls)
      },

      drawSelection(){
        let w = 200;
        let h = 100
        const rect = this.canvas.getBoundingClientRect();
        const left = rect.left;
        const top = rect.top;

        this.selDivStyle.imgWidth = w;
        this.selDivStyle.imgHeight = h;
        this.selDivStyle.hW = w / 2;
        this.selDivStyle.hH = h / 2;
        this.selDivStyle.fX = this.camera.x + w + left + this.selDivStyle.hW;
        this.selDivStyle.fY = this.camera.y + h + top + this.selDivStyle.hH;

        console.log(this.canvas, this.canvas.top)
        console.log(this.selDivStyle.fX, this.selDivStyle.fY)
        // Calculate imgAngle based on your requirements
        this.selDivStyle.imgAngle = Math.PI / 4; // Example angle of 45 degrees
      },

      drawDragAnchor(x, y, w, h, angle){

        const rect = this.canvas.getBoundingClientRect();
        const left = rect.left;
        const top = rect.top;

        w = w * this.zoomLevel;
        h = h * this.zoomLevel

        this.selDivStyle.imgWidth = w;
        this.selDivStyle.imgHeight = h;
        this.selDivStyle.hW = w / 2;
        this.selDivStyle.hH = h / 2;
        this.selDivStyle.fX = ( this.camera.x + x ) * this.zoomLevel + this.selDivStyle.hW + left;
        this.selDivStyle.fY = ( this.camera.y + y ) * this.zoomLevel + this.selDivStyle.hH  + top;

        // Calculate imgAngle based on your requirements
        this.selDivStyle.imgAngle = angle; // Example angle of 45 degrees
      },


      detectDoubleTap(event) {
        const curTime = new Date().getTime();
        const tapLen = curTime - this.lastTap;

        if (tapLen < 500 && tapLen > 0) {
          // Double tap detected

          this.handleSelect(event);

          console.log('Double tapped!');
        } else {
          // Not a double tap, start a timer
          this.timeout = setTimeout(() => {
            clearTimeout(this.timeout);
          }, 500);
        }

        this.lastTap = curTime;
      },

      handleMouseMove(e) {
        let diff = {
              x : Math.round((e.clientX - this.startPos.x) / 10) * 10,
              y : Math.round((e.clientY - this.startPos.y) / 10) * 10,
          };
          if(e.which == 2) {
            this.camera.x = this.startPos.originX + diff.x;
            this.camera.y = this.startPos.originY + diff.y;
            this.camera.x = Math.min(0, this.camera.x);
            this.camera.y = Math.min(0, this.camera.y);
            ////this.drawBG(this.ctx2)
          }
        let mouse = this.getMouseCoords(this.canvas, e);
        if (this.prtcls)
        {
          let arr = this.prtcls.map(e => this.cursorInRect(mouse.x, mouse.y, e.x, e.y, e.w, e.h, e.angle))
          !arr.every(e => e === false)  && (this.canv!='imanager') ? this.canvas.classList.add('pointer') : this.canvas.classList.remove('pointer')          
        }
        else
        {
          this.canvas.classList.remove('pointer')
        }
      },

      handleMouseDown(e) {
        console.log("is SCALE: ", this.isScale, " ROTATE: ", this.isRotate)
        if(e.which == 2) {
            console.log("camera move---")
            this.canvas.classList.add('hand');
            this.startPos = {
                  x : e.clientX,
                  y : e.clientY,
                  originX: this.camera.x,
                  originY: this.camera.y
              }
            }

      },

      handleMouseUp(e) {
        if(e.which == 2) {
          this.canvas.classList.remove('hand')
        } else {
          if (this.prtcls)
          this.prtcls.forEach(e => {
            e.selected = false
          })
        }
        this.isScale = false;
        this.isRotate = false;
      },

      handleTouchStart(event) {
        const touchPoints = Array.from(event.touches);
        if (touchPoints.length === 2) {
          // Calculate the initial distance between two touch points
          const dx = touchPoints[0].clientX - touchPoints[1].clientX;
          const dy = touchPoints[0].clientY - touchPoints[1].clientY;
          this.pinchStartDistance = Math.sqrt(dx * dx + dy * dy);
          this.initialZoom = 1;
        }
      },

      handleTouchMove(event) {
        const touchPoints = Array.from(event.touches);
        console.log("touch - length -----", touchPoints.length)
        if (touchPoints.length === 2) {
          // Calculate the current distance between two touch points
          const dx = touchPoints[0].clientX - touchPoints[1].clientX;
          const dy = touchPoints[0].clientY - touchPoints[1].clientY;
          const pinchCurrentDistance = Math.sqrt(dx * dx + dy * dy);

          // Calculate the zoom factor based on the pinch distance change
          const zoomFactor = pinchCurrentDistance / this.pinchStartDistance;


          const zoomSpeed = 0.1; // Adjust this value to control the zoom speed
          this.zoomLevel -= (zoomFactor > this.initialZoom ? 1 : -1) * zoomSpeed;
          this.zoomLevel = Math.max(0.5, Math.min(this.zoomLevel, 8));
          // Perform the zoom action based on the zoom factor
          if (zoomFactor > this.initialZoom) {
            // Zoom in
            console.log('Zoom in');
          } else {
            // Zoom out
            console.log('Zoom out');
          }
          ////this.drawBG(this.ctx2)


          // Update the initial zoom for the next touch move event
          this.initialZoom = zoomFactor;
        }
      },

      handleSliderChange(value) {
        // Do something with the new value
        console.log(675,value)
        this.zoomLevel = 0.5 + value;
        ////this.drawBG(this.ctx2)
      },
    },

    data() {
      return {
        dialogSave:false,
        dialogNew:false,
        hall:{},
        activeVHall:null,
        leftMenuC:null,
        leftMenuD:null,
		
        closeEnough: 10,
        dragTL: false,
        dragBL: false,
        dragTR: false,
        dragBR: false,
        drag: false,
        mouseX: null,
        mouseY: null,
        widthPercent: 0.95,
        heightPercent: 0.95,
        zoomLevel: 1,
        prtcls: [],
        startPos: {},
        canvas: null,
        canvas2: null,
        ctx: null,
        ctx2: null,
        w: 0,
        h: 0,
        camera: {
          x : 0,
          y : 0
        },
        setting: {
          diff: 10
        },
        isCameraMove: false,
        isRotate: false,
        isScale: false,
        scale_direction: DIRECTION.LEFT,

        lastTap : 0,
        timeout : null,
        pinchStartDistance : 0,
        initialZoom : 1,
        isPressed : false,
        pressTimer : null,

        selDivStyle: { 
          imageUrl: 'path/to/image.jpg',
          imgWidth: 0,
          imgHeight: 0,
          imgAngle: 0,
          hW: 0,
          hH: 0,
          fX: 0,
          fY: 0,
        },
        vh:null,
        /*
        activeDate:null,
        activeMealId:null,
        */
        activeSlot:null,
        activeHallId:null,
        //activeLocationId:null,
        halls:null,
        meals:null,
        date:null,
        loading:false,
        slctdTbls:[],
        wHeight: window.innerHeight,
        wWidth: window.innerWidth,
        currentBooking:null,

      }
    },

    mounted() {
      this.canvas = document.getElementById('mycanvas')
      this.canvas2 = document.getElementById('mycanvas2')
      this.ctx = this.canvas.getContext('2d')
      this.ctx2 = this.canvas2.getContext('2d')
      this.w = this.canvas.width = this.canvas2.width = (this.canvasWidth||this.wWidth) * this.widthPercent;
      this.h = this.canvas.height = this.canvas2.height = (this.canvasHeight||800);//* this.heightPercent;

      console.log(1249,window.innerWidth, window.innerWidth,this.w,this.h)
      this.leftMenuC=document.getElementById('leftMenuC')
      this.leftMenuD=document.getElementById('leftMenuD')
      console.log(1250,window.innerWidth, window.innerHeight,this.w,this.h,this.widthPercent)
      console.log(1251,this.leftMenuC,this.leftMenuC.offsetWidth,this.leftMenuC.offsetHeight)
      //console.log(1252,this.leftMenuD,this.leftMenuD.offsetWidth,this.leftMenuD.offsetHeight,this.leftMenuD.clientWidth,this.leftMenuD.clientHeight)  

      this.canvas.style.backgroundColor = 'transparent'
      this.canvas2.style.backgroundColor = 'white'

      this.ctx.lineWidth = 2
      this.ctx.textAlign = 'center'
      this.ctx.textBaseline = 'middle'
      this.ctx.font = '10px Arial'
      
      ////this.drawBG(this.ctx2)

      // let arr = new Array(40).fill('empty').map(() => Math.floor(Math.random() * 100))


      window.addEventListener('resize', () => {
            this.w = this.canvas.width = this.canvas2.width = (this.canvasWidth||this.wWidth) * this.widthPercent;
            this.h = this.canvas.height = this.canvas2.height = (this.canvasHeight|800);//* this.heightPercent;
            ////this.drawBG(this.ctx2)
            console.log(722,this.widthPercent)
      })

      this.canvas.addEventListener('click', e => {
          // let mouse = this.getMouseCoords(this.canvas, e);
          this.handleSelect(e);
          //console.log(JSON.stringify(this.getIt()), e)
          
      })

      this.canvas.addEventListener('dblclick', e => {
        //this.handleSelect(e);
        console.log(798,e)

      })

      window.addEventListener('mousemove', e => {
        this.handleMouseMove(e);
      })

      window.addEventListener('mousedown', e => {
        this.handleMouseDown(e);
      })

      window.addEventListener('mouseup', e => {
        this.handleMouseUp(e);
      })


      window.addEventListener('touchstart', (event) => {
        console.log("touch start")
        
        // ADD Keep press Event and select item
        if(!this.isRotate && !this.isScale) {
          this.isPressed = true;
          let that = this;
          this.pressTimer = setTimeout(function() {
            // Your code for "keep pressed" action here
            that.handleSelect(event.touches[0]);
            console.log("Keep pressed action");
          }, 200); // Adjust the duration (in milliseconds) as needed
        }
      });

      // Add an event listener to the touchmove event
      window.addEventListener('touchmove', (event) => {
        console.log(event)
        /*

        this.handleTouchMove(event);
        // Check if there are at least two touch points
        let e = event.touches[0];
        if (event.touches.length >= 2) {       
          console.log(e.clientX)   
          let diff = {
              x : Math.round((e.clientX - this.startPos.x) / 10) * 10,
              y : Math.round((e.clientY - this.startPos.y) / 10) * 10,
          };
          // Handle the two-finger touch movement
          this.camera.x = this.startPos.originX + diff.x;
          this.camera.y = this.startPos.originY + diff.y;
          this.camera.x = Math.min(0, this.camera.x);
          this.camera.y = Math.min(0, this.camera.y);
          ////this.drawBG(this.ctx2)
        }

        this.handleMouseMove(event.touches[0])
        */
      });
      
      window.addEventListener('touchend', (event) => {
        this.isPressed = false;
        clearTimeout(this.pressTimer);

        event.width = 1;
        this.handleMouseUp(event);
      })

      this.canvas.addEventListener("contextmenu", e => {
          //event.preventDefault();
        console.log(e)
      });

      //this.canvas.addEventListener('wheel', this.handleScroll);

      this.canvas.addEventListener('wheel', event => {
        //console.log(1038,event)
        const { ctrlKey } = event
        if (ctrlKey) {
            event.preventDefault();
            return
        }
      }) 
      
     

      this.animate()
    },

    // Handle functions

}
</script>

<style lang="scss">

  .table-container{
    z-index: 10;
  }


  .arch-container img {
    width: 50px;
    height: 17px;
  }

  .warp-container {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .wrap {
      position: relative;
      z-index: 2;
  }

  .wrap div {
      box-shadow: 2px 2px 6px -2px rgba(0,0,0,0.75);
  }
  .wrap2 {

      position: absolute;
      z-index: 1;
      background-color: 'white'
  }

  #mycanvas {
      display: block;
      box-sizing: border-box;
      border: 1px solid #ffffff
  }
  #mycanvas2 {
      display: block;
      box-sizing: border-box;
  }

  .pointer {
      cursor: pointer;
  }

</style>